import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "msg msg-ok"
}
const _hoisted_2 = {
  key: 1,
  class: "msg msg-invalid"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!

  return (_ctx.met)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_Icon, { icon: "icon-good.svg" }),
        _createTextVNode(" " + _toDisplayString(_ctx.msg), 1)
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
        _createVNode(_component_Icon, { icon: "icon-error.svg" }),
        _createTextVNode(" " + _toDisplayString(_ctx.msg), 1)
      ]))
}